(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["es-community-stats"] && !Shopify.designMode) return;
  try {
    
(function () {
  function animate(el) {
    var raw = el.getAttribute('data-value') || '';
    var m = raw.match(/^(\D*)([\d.,]+)(.*)$/);
    if (!m) return;

    var prefix = m[1], numStr = m[2], suffix = m[3];
    var grouped = /\d\.\d{3}/.test(numStr);
    var clean = numStr.replace(/\./g, '').replace(',', '.');
    var target = parseFloat(clean);
    if (isNaN(target)) return;

    var decimals = (clean.split('.')[1] || '').length;
    var duration = 1600;
    var start = null;

    function fmt(v) {
      return v.toLocaleString('de-DE', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
        useGrouping: grouped
      });
    }

    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = prefix + fmt(target * eased) + suffix;
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = raw;
    }

    requestAnimationFrame(step);
  }

  function init(root) {
    var sections = (root || document).querySelectorAll('.es-stats--count');
    if (!sections.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        animate(entry.target);
        io.unobserve(entry.target);
      });
    }, { threshold: 0.4 });

    sections.forEach(function (section) {
      section.querySelectorAll('.es-stats__number[data-count]').forEach(function (el) {
        io.observe(el);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
